/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OmniGenerateIFrameUrlResponse } from './OmniGenerateIFrameUrlResponse';
import {
    OmniGenerateIFrameUrlResponseFromJSON,
    OmniGenerateIFrameUrlResponseFromJSONTyped,
    OmniGenerateIFrameUrlResponseToJSON,
} from './OmniGenerateIFrameUrlResponse';

/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrl201Response
 */
export interface OmniGenerateIFrameUrl201Response {
    /**
     * 
     * @type {OmniGenerateIFrameUrlResponse}
     * @memberof OmniGenerateIFrameUrl201Response
     */
    data?: OmniGenerateIFrameUrlResponse;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrl201Response interface.
 */
export function instanceOfOmniGenerateIFrameUrl201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OmniGenerateIFrameUrl201ResponseFromJSON(json: any): OmniGenerateIFrameUrl201Response {
    return OmniGenerateIFrameUrl201ResponseFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrl201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrl201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : OmniGenerateIFrameUrlResponseFromJSON(json['data']),
    };
}

export function OmniGenerateIFrameUrl201ResponseToJSON(value?: OmniGenerateIFrameUrl201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': OmniGenerateIFrameUrlResponseToJSON(value.data),
    };
}

